import React, { useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

// Internal Imports
import { GRID } from "../../constants";

// Css Imports
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

// Destructuring
const { GRID_PAGE_NO_BACK_SWIPE } = GRID;

const AgGridWrapper = props => {
  const { onGridReady, columnDefs, rowData, ...otherProps } = props;
  // componentDidMount
  useEffect(() => {
    document.body.classList.toggle(GRID_PAGE_NO_BACK_SWIPE);
  }, []);

  // componentWillUnMount
  useEffect(
    () => () => {
      document.body.classList.remove(GRID_PAGE_NO_BACK_SWIPE);
    },
    [],
  );

  return (
    <AgGridReact
      reactNext
      onGridReady={params => {
        props.onGridReady(params);
      }}
      columnDefs={props.columnData}
      rowData={props.rowData}
      {...otherProps}
    />
  );
};

export default AgGridWrapper;



// WEBPACK FOOTER //
// ./src/components/AgGridWrapper/AgGridWrapper.js